import React from "react";

const InnerPageSection = ({ title, paragraphs = [], images = [], listItems = [] }) => {
  return (
    <section className="inner-page pt-6">
      <div className="container">
        {title && <h4>{title}</h4>}

        {paragraphs.map((text, idx) => (
          <p key={idx}>{text}</p>
        ))}

        {images.length > 0 && (
          <div className="inner-img-area my-4">
            {images.map((src, idx) => (
              <img
                key={idx}
                src={src}
                alt={`Inner image ${idx + 1}`}
                className="footer-logo"
              />
            ))}
          </div>
        )}

        {/* {listItems.length > 0 && (
          <ul>
            {listItems.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        )} */}
      </div>
    </section>
  );
};

export default InnerPageSection;
